// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../../assets/stylesheets/variables.scss\"","smallWidth":"768px","mobileThreshold":"575px","useTemplate":"PreviewTemplate_useTemplate__SQz5Z"};